module.exports = __webpack_public_path__ + "img/6228185.png";